// import React from 'react';
// import { IfmsRoute }from '../../../config/types';

// const opReportSet = React.lazy(() => import('../opReport/opReportSet'));

// const routes:Array<IfmsRoute> = [
//   {path: '/opReport', component: opReportSet},
// ];

// export default routes;
import React from 'react';
import { IfmsRoute }from '../../../config/types';

const DutyPendingsView =  React.lazy(() => import('../../common/reports/DutyPendingsView')); 
const VolumeReportView =  React.lazy(() => import('../../common/reports/VolumeReportView')); 
const VendorCostView =  React.lazy(() => import('../../common/reports/VendorCostView')); 
const ExpenseView =  React.lazy(() => import('../../common/reports/ExpenseView')); 
const OperationPerformanceView =  React.lazy(() => import('../../common/reports/OperationPerformanceView')); 
const CustomerActivityView =  React.lazy(() => import('../../common/reports/CustomerActivityView')); 
const BranchPerformanceView =  React.lazy(() => import('../../common/reports/BranchPerformanceView')); 
const ProfitAndVolumeSummaryView =  React.lazy(() => import('../../common/reports/ProfitAndVolumeSummaryView')); 

const routes:Array<IfmsRoute> = [

   { path: '/opReport/dutyPendings', component: DutyPendingsView },
   { path: '/opReport/estProfit', component: ProfitAndVolumeSummaryView },
   { path: '/opReport/grossProfit', component: ProfitAndVolumeSummaryView },
   { path: '/opReport/cost', component: VendorCostView },
   { path: '/opReport/expense', component: ExpenseView },
   { path: '/opReport/volume', component: VolumeReportView },
   { path: '/opReport/salesPerformance', component: ProfitAndVolumeSummaryView },
   { path: '/opReport/customerActivity', component: CustomerActivityView },
   { path: '/opReport/opPerformance', component: OperationPerformanceView },
   { path: '/opReport/branchPerformance', component: BranchPerformanceView },
];

export default routes;
